import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { LocalizedProductCategoryResponseModel } from '../models/LocalizedProductCategoryResponseModel';
import { SortInfo } from 'src/app/shared/models/queryparams/sortinfo.model';
import { PageInfo } from 'src/app/shared/models/queryparams/pageinfo.model';
import { ProductCategoryModel } from '../models/ProductCategoryModel';
import { ProductCategoryCodesAndNames } from '../models/ProductCategoryCodesAndName';
import { ServiceSortOrder } from '../models/service-sort-order';
import { ProductCategoryGridParams } from '../models/product-category-grid-params';
import { IServiceGrid } from '../models/service-grid';
import { Store } from "@ngrx/store";
import { getLoggedInUserInfo } from "src/app/state";
import { State } from "src/app/state/app.state";

@Injectable({
  providedIn: 'root'
})
export class ProductCategoryService {

  private isNewCategory: boolean = true;
  private currentFilterTextValue: string = '';
  private sortInfo: SortInfo;
  private pageInfo: PageInfo;
  private editingItem: number = 0;
  private preferredLanguageId : number = 1;
  
  private appConfig!: AppConfigurations;
  private productCategoryUrl: string = '';

  constructor(private appInitService: AppInitService, private http: HttpClient, private store: Store<State>) {

    this.sortInfo = new SortInfo();
    this.pageInfo = new PageInfo();
    this.appInitService.getAppConfiguration$().subscribe({
      next: config => this._onReceiveAppConfig(config)
    })
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations){
    this.appConfig = appConfig;
    this.productCategoryUrl = `${this.appConfig.adminApi.baseApiUrl}${this.appConfig.adminApi.productcategoryController}`;
  }

    getPreferredLanguage() {
    this.store.select(getLoggedInUserInfo).subscribe((user) => {
      if (user !== undefined && user !== null && user['preferredLanguage']) {
        this.preferredLanguageId = user['preferredLanguage'];
      }
    }
    );
  }

  private get languageParam(): HttpParams {
      return new HttpParams().set('preferredLanguageId', this.preferredLanguageId.toString());
  }


  public setEditingItemId(id: number) {
    this.editingItem = id;
  }
  public getEditingItemId() {
    return this.editingItem;
  }

  public getLocalizedGridData(gridParams:ProductCategoryGridParams): Observable<IServiceGrid<LocalizedProductCategoryResponseModel>> {
    let queryparams = this.getQueryParams(gridParams);
    const url = `${this.productCategoryUrl}/productCategories/${queryparams}`;
    let tempData = this.http.get<IServiceGrid<LocalizedProductCategoryResponseModel>>(url);
    return tempData;
  }

  private getQueryParams(params: ProductCategoryGridParams): string {
    const skip = (params.pageInfo.Page - 1) * params.pageInfo.PageSize;
    return `?language=${params.language}&SearchText=${params.searchText}&PageInfo.Page=${params.pageInfo.Page}&PageInfo.PageSize=${params.pageInfo.PageSize}
  &Pageinfo.Skip=${skip}&SortInfo.SortColumn=${params.sortInfo.SortColumn}&SortInfo.SortDirection=${params.sortInfo.sortDirection}&manualSort=${params.manualSort}`;
  }
  public getProductCategoryDisplayData(): Observable<ProductCategoryCodesAndNames[]> {
     this.getPreferredLanguage();
    const url = `${this.productCategoryUrl}/sortorder`;
    return this.http.get<ProductCategoryCodesAndNames[]>(url, {params: this.languageParam});
  }

  public getProductCategoryGridData(): Observable<ProductCategoryModel[]> {
    const url = `${this.productCategoryUrl}`;
    let tempData = this.http.get<ProductCategoryModel[]>(url);
    return tempData;
  }

  public createNewCategory(productCategory: ProductCategoryModel) {
    const url = `${this.productCategoryUrl}`;
    let res = this.http.post(url, productCategory);
    return res;
  }

  public updateProductCategory(productCategory: ProductCategoryModel) {
    const url = `${this.productCategoryUrl}`;
    let res = this.http.put(url, productCategory);
    return res;
  }

  public rearrange(requestData: any) {
    const url = `${this.productCategoryUrl}/reorder`;
    return this.http.patch<any[]>(url, requestData);
  }

  public deleteProductCategory(deletingItem: LocalizedProductCategoryResponseModel) {
    const url = `${this.productCategoryUrl}/${deletingItem.id}`;
    return this.http.delete<any[]>(url);
  }

  public getProductCategories(): Observable<any> {
    const mockResult = [
      {
        serviceCategoryId: 1,
        serviceCategoryDisplayName: 'New Accounts'
      },
      {
        serviceCategoryId: 2,
        serviceCategoryDisplayName: 'Card Services'
      }
    ];

    return of<any>(mockResult);
  }

  /*
  *   Set the filter text of the searchfield in the grid view
  */
  public setCurrentFilterTextValue(val: string) {
    this.currentFilterTextValue = val;
  }

  public isNewCategoryCreating() {
    return this.isNewCategory;
  }

  public setNewCategoryCreating(isNewCategory: boolean) {
    this.isNewCategory = isNewCategory;
  }

  /*
  *   Get the filter text of the searchfield in the grid view
  */
  public getCurrentFilterTextValue() {
    return this.currentFilterTextValue;
  }

  public setSortInfo(sortInfo: SortInfo) {
    this.sortInfo = sortInfo;
  }

  public getSortInfo(): SortInfo {
    return this.sortInfo;
  }

  public setPageInfo(pageInfo: PageInfo) {
    this.pageInfo = pageInfo;
  }

  public getPageInfo() {
    return this.pageInfo;
  }

  public resetData() {
    // this.recordToEdit = null;
    // this.currentlySelectedLanguage = null;
    this.currentFilterTextValue = '';
    this.isNewCategory = true;
    this.sortInfo = new SortInfo();
    this.pageInfo = new PageInfo();
  }

  getServicesForSortByCategoryId(categoryId : number,locationId:number,isFromLocationModule:boolean) : Observable<ServiceSortOrder[]>
  {
    this.getPreferredLanguage();
    return this.http.get<ServiceSortOrder[]>(`${this.productCategoryUrl}/${categoryId}/${locationId}/${isFromLocationModule}/services`,
      {params: this.languageParam});
  }


}
